import React from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import FollowButton from './FollowButton';
import { useAuth } from '../../context/AuthContext';

const { FiCheckCircle, FiUsers, FiDollarSign } = FiIcons;

const ArtistHero = ({ artist }) => {
  const { user } = useAuth();
  const isOwner = user?.id && artist?.user_id === user.id;

  return (
    <header className="relative h-[60vh] overflow-hidden">
      {artist.cover_image ? (
        <img src={artist.cover_image} alt={artist.name}
          className="w-full h-full object-cover grayscale opacity-40" />
      ) : (
        <div className="w-full h-full bg-gradient-to-br from-zinc-900 to-zinc-950" />
      )}
      <div className="absolute inset-0 bg-gradient-to-t from-zinc-950 via-zinc-950/30 to-transparent" />

      <div className="absolute bottom-12 left-8 md:left-16 space-y-4 max-w-4xl">
        <div className="flex flex-wrap items-center gap-4">
          {artist.verified && (
            <span className="px-4 py-1.5 bg-blue-600 text-white text-xs font-black tracking-widest rounded-full flex items-center gap-2">
              <SafeIcon icon={FiCheckCircle} /> VERIFIED
            </span>
          )}
          {artist.genre && (
            <span className="text-zinc-300 text-sm font-black tracking-wider uppercase">{artist.genre}</span>
          )}
        </div>

        <h1 className="text-6xl md:text-9xl font-black tracking-tighter leading-[0.85] text-white">
          {artist.name}
        </h1>

        <div className="flex flex-wrap items-center gap-6">
          <div className="flex items-center gap-2 text-zinc-300">
            <SafeIcon icon={FiUsers} className="text-lg" />
            <span className="font-black text-lg">{(artist.supporter_count || 0).toLocaleString()}</span>
            <span className="text-zinc-500 font-bold text-sm">supporters</span>
          </div>
          <div className="flex items-center gap-2 text-zinc-300">
            <SafeIcon icon={FiDollarSign} className="text-lg" />
            <span className="font-black text-lg">${(artist.total_earned || 0).toLocaleString()}</span>
            <span className="text-zinc-500 font-bold text-sm">earned</span>
          </div>
          {!isOwner && (
            <FollowButton artistId={artist.id} userId={user?.id} />
          )}
        </div>
      </div>
    </header>
  );
};

export default ArtistHero;